import { State, Action, StateContext, Selector } from '@ngxs/store';
import { SetTheme, ResetLayout } from './layout.actions';
import { LayoutStateModel } from './layout.state.model';
import { LayoutThemeEnum } from '../models/layout-theme.enum';

const initialState = {
  theme: LayoutThemeEnum.Light
};

@State<LayoutStateModel>({
  name: 'layout',
  defaults: initialState
})
export class LayoutState {
  @Selector()
  static getTheme(state: LayoutStateModel) {
    return state.theme;
  }


  @Action(SetTheme)
  setTheme({ patchState }: StateContext<LayoutStateModel>, { theme }: SetTheme) {
    patchState({
      theme: theme
    });
  }

  @Action(ResetLayout)
  resetLayout(context: StateContext<LayoutStateModel>, action: ResetLayout) {
    context.setState(initialState);
  }
}
